@if (params.data && !params.node.rowPinned) {
  <div
    class="flex items-center justify-center h-full"
    (click)="$event.stopPropagation()"
  >
    <app-action-menu
      variant="icon"
      [customItems]="menuItems"
      (customAction)="onMenuAction($event)"
    ></app-action-menu>
  </div>
}
